<template>
  <div class="annals">
    <!-- <el-container class="annals"> -->
    <div class="">
      <el-divider content-position="left">年报服务</el-divider>
      <el-row>
        <el-col :span="4">
          <el-col :span="23">
            <el-select v-model="searchArr.cid" filterable remote reserve-keyword placeholder="请输入公司字号筛选公司" size="mini"
              clearable @change="handleCompanyChange" @clear="handleClear" :remote-method="remoteCompanyMethod" :loading="loading">
              <el-option v-for="company in companies" :key="company.id" :label="company.company_name"
                :value="company.id">
              </el-option>
            </el-select>
          </el-col>
        </el-col>
        <el-col :span="4">
          <el-col :span="23">
            <el-date-picker v-model="searchArr.dateTime" type="year" size="mini" format="yyyy 年" value-format="yyyy"
              :picker-options="pickerOptions" @change="handleDateTimeChange" placeholder="选择年份">
            </el-date-picker>
          </el-col>
        </el-col>
        <el-col :span="4">
          <el-col :span="23">
            <el-select collapse-tags v-model="searchArr.status" placeholder="请选择通知状态" @change="handleCompanyChange"
              size="mini" clearable>
              <el-option :value="1" label="未通知"></el-option>
              <el-option :value="2" label="已通知"></el-option>
              <el-option :value="3" label="已提交"></el-option>
              <el-option :value="4" label="已上传"></el-option>
              <el-option :value="5" label="已完成"></el-option>
              <el-option :value="6" label="未完成"></el-option>
            </el-select>
          </el-col>
        </el-col>
        <el-col :span="2">
          <el-col :span="22">
            <el-popover placement="bottom-start" v-model="searchVisible" width="500">
              <el-row style="margin-bottom: 0.4rem; padding-top: 0.5rem">
                <el-col :span="6" style="margin-top: 0.1rem">理票会计</el-col>
                <el-col :span="18">
                  <el-cascader
                    v-model="searchArr.acc_id"
                    placeholder="请选择理票会计"
                    :options="allusersAddition"
                    size="mini"
                    :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
                    clearable
                    filterable
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">记账报税会计</el-col>
                <el-col :span="18">
                  <el-cascader
                    v-model="searchArr.advisory_id"
                    placeholder="请选择记账报税会计"
                    :options="allusersAddition"
                    size="mini"
                    :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
                    clearable
                    filterable
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">客服会计</el-col>
                <el-col :span="18">
                  <el-cascader
                    v-model="searchArr.ass_id"
                    placeholder="请选择客服会计"
                    :options="allusersAddition"
                    size="mini"
                    :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
                    clearable
                    filterable
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">开票会计</el-col>
                <el-col :span="18">
                  <el-cascader
                    v-model="searchArr.invoice_id"
                    placeholder="请选择开票会计"
                    :options="allusersAddition"
                    size="mini"
                    :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }"
                    clearable
                    filterable
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">财税负责人</el-col>
                <el-col :span="18">
                  <el-cascader
                    v-model="searchArr.leader_id"
                    placeholder="请选择财税负责人"
                    :options="allusersAddition"
                    size="mini"
                    :props="{ expandTrigger: 'hover', multiple: true, emitPath: false}"
                    clearable
                    filterable
                    :filter-method="filterOptions"
                  >
                  </el-cascader>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">所属业务</el-col>
                <el-col :span="18">
                  <el-cascader v-model="searchArr.saler_id" placeholder="请选择所属业务" :options="allusersAddition"
                    size="mini" :props="{ expandTrigger: 'hover', multiple: true, emitPath: false }" clearable
                    filterable :filter-method="filterOptions">
                  </el-cascader>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="5" style="margin-top: 0.1rem">是否绑定客户</el-col>
                <el-col :span="8">
                  <el-radio-group v-model="searchArr.is_bind" size="mini">
                    <el-radio-button label="1">未绑定</el-radio-button>
                    <el-radio-button label="2">已绑定</el-radio-button>
                  </el-radio-group>
                </el-col>
                <el-col :span="4" style="margin-top: 0.1rem">是否关注</el-col>
                <el-col :span="7">
                  <el-radio-group v-model="searchArr.is_subscribe" size="mini">
                    <el-radio-button label="1">未关注</el-radio-button>
                    <el-radio-button label="2">已关注</el-radio-button>
                  </el-radio-group>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="5" style="margin-top: 0.1rem">成立时间条件</el-col>
                <el-col :span="8">
                  <el-radio-group v-model="searchArr.is_date_of_est" size="mini">
                    <el-radio-button label="1">是&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-radio-button>
                    <el-radio-button label="2">否&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-radio-button>
                  </el-radio-group>
                </el-col>
                <el-col :span="4" style="margin-top: 0.1rem">有无档案</el-col>
                <el-col :span="7">
                  <el-radio-group v-model="searchArr.archives" size="mini">
                    <el-radio-button label="1">有档案</el-radio-button>
                    <el-radio-button label="2">无档案</el-radio-button>
                  </el-radio-group>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">有无年报手机号</el-col>
                <el-col :span="18">
                  <el-radio-group v-model="searchArr.annual_phone" size="mini">
                    <el-radio-button label="1">有&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-radio-button>
                    <el-radio-button label="2">无&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-radio-button>
                  </el-radio-group>
                  <el-button style="margin-left: 0.2rem" size="mini" type="primary"
                    @click.native="clearAnnualPhone">清除</el-button>
                </el-col>
              </el-row>
              <!-- <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
              <el-col :span="6" style="margin-top: 0.1rem">企业状态：</el-col>
              <el-col :span="18">
                <el-radio-group v-model="searchArr.regStatus" size="mini">
                  <el-radio label="1" border>正&nbsp;&nbsp;&nbsp;&nbsp;常</el-radio>
                  <el-radio label="2" border>吊/注销</el-radio>
                </el-radio-group>
              </el-col>
            </el-row> -->
              <!-- <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">

              </el-row> -->
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">成立时间：</el-col>
                <el-col :span="18">
                  <el-date-picker v-model="searchArr.date_of_est" type="year" size="mini" format="yyyy 年"
                    value-format="yyyy" placeholder="选择年份">
                  </el-date-picker>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">企业状态：</el-col>
                <el-col :span="18">
                  <el-select v-model="searchArr.companyStatus" placeholder="企业状态" style="width: 100%" clearable
                    filterable multiple size="mini" @click.native="getCompanyStatus">
                    <el-option v-for="item in options_company_status" :key="item" :label="item" :value="item">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.3rem">
                <el-col :span="6" style="margin-top: 0.1rem">园区：</el-col>
                <el-col :span="18">
                  <el-select v-model="searchArr.base" placeholder="所属区域" style="width: 48%" clearable filterable
                    size="mini" @click.native="getBase" @change="getReal">
                    <el-option v-for="item in options_base" :key="item.id" :label="item.areaName" :value="item.id">
                    </el-option>
                  </el-select>
                  -
                  <el-select v-model="searchArr.real" multiple placeholder="园区名称" style="width: 48%" clearable
                    filterable size="mini">
                    <el-option v-for="item in options_real" :key="item.id" :label="item.areaName" :value="item.id">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-row style="margin-bottom: 0.4rem; margin-top: 0.4rem; text-align: center;">
                <el-col >
                  <el-button size="mini" @click="handleClearSearchGetData">清除</el-button>
                  <el-button type="primary" @click="handleSearchGetData" size="mini">查询</el-button>
                </el-col>
              </el-row>
              <el-button slot="reference" size="mini">筛选</el-button>
            </el-popover>
          </el-col>
        </el-col>
        <el-col :span="2">
          <el-tooltip content="导出年报服务已提醒的企业" placement="top">
            <el-button type="warning" size="mini" @click="doExport">导出</el-button>
          </el-tooltip>
        </el-col>
        <!-- <el-col :span="2" v-if="searchArr.status === 1 || searchArr.status === 2"> -->
        <el-col :span="3" v-if="searchArr.status === 1 || searchArr.status === 2">
          <el-tooltip content="批量提醒企业添加年报地址信息!" placement="top">
            <el-button type="primary" size="mini" @click="handleBatchAnnals">批量提醒</el-button>
          </el-tooltip>
          <el-tooltip content="直接点击无需选择!" placement="top">
            <i class="el-icon-info" style="color: #f56c6c"></i>
          </el-tooltip>
        </el-col>
        <el-col :span="3">
          <el-dropdown>
            <el-button type="primary" size="mini">
              更多菜单<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-tooltip content="批量更新年报信息" placement="top">
                  <el-button type="primary" size="mini" class="btn-w"
                    @click="updateAnnal">批量更新年报信息&nbsp;&nbsp;&nbsp;</el-button>
                </el-tooltip>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-tooltip content="批量同步年报手机号" placement="top">
                  <el-button type="primary" class="btn-w" size="mini" @click="multiSetAnnualPhone">批量同步年报手机号</el-button>
                </el-tooltip>
                <el-tooltip content="将客户的服务对接人号码、会员号码、下单号码、法人号码同步为年报手机号。优先同步最近的下单手机号。已有年报手机号的不同步。" placement="top">
                  <i class="el-icon-info" style="color: #f56c6c"></i>
                </el-tooltip>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-tooltip class="item" effect="dark" content="再次通知客户填写年报地址" placement="top">
                  <el-popconfirm title="确认通知吗？" @onConfirm="doConfirm">
                    <el-button class="btn-w" type="primary" size="mini" slot="reference">再次通知客户填写年报地址</el-button>
                  </el-popconfirm>
                </el-tooltip>
                <!-- <el-tooltip content="再次通知客户填写年报地址" placement="top">
                  <el-button class="btn-w" type="primary" size="mini"
                    @click="multiSetAnnualPhone">再次通知客户填写年报地址</el-button>
                </el-tooltip> -->
                <el-tooltip content="直接点击按钮即可,系统会筛选出未提醒过的客户,或已经提醒过,但仍未填写年报地址的客户,进行再次通知。(可多次点击,注意不要频繁点击!)"
                  placement="top">
                  <i class="el-icon-info" style="color: #f56c6c"></i>
                </el-tooltip>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-col>
        <!-- <el-col :span="3">
          <el-tooltip content="批量更新年报信息" placement="top">
            <el-button type="primary" size="mini" @click="updateAnnal">批量更新年报信息</el-button>
          </el-tooltip>
        </el-col>
        <el-col :span="4">
          <el-tooltip content="批量同步年报手机号" placement="top">
            <el-button type="primary" size="mini" @click="multiSetAnnualPhone">批量同步年报手机号</el-button>
          </el-tooltip>
          <el-tooltip content="将客户的服务对接人号码、会员号码、下单号码、法人号码同步为年报手机号。优先同步最近的下单手机号。已有年报手机号的不同步。" placement="top">
            <i class="el-icon-info" style="color:#F56C6C"></i>
          </el-tooltip>
        </el-col> -->
      </el-row>
      <el-row style="margin: 0.2rem 0">
        <el-col> 日期：{{ list_year }} </el-col>
      </el-row>
    </div>

    <!-- <el-main class="main-style"> -->
    <!-- max-height="570" -->
    <el-table :data="pageData" style="width: 100%" @selection-change="getIdForAnnal" border height="calc(100vh - 5rem)">
      <el-table-column type="selection" width="55" fixed="left"> </el-table-column>
      <el-table-column label="公司名称" width="300" fixed>
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.company_name" placement="top" style="">
            <div class="company_hover" style="display: inline-block; vertical-align: top">
              <span class="count_style" style="">
                <el-link type="primary" @click="handleOpen(scope.row, scope.$index)">{{
          scope.row.company_name
        }}</el-link>
              </span>
            </div>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="复制" placement="top" style=""><i class="el-icon-document-copy"
              style="
                margin-left: 0.1rem;
                margin-top: 0.1rem;
                cursor: pointer;
                vertical-align: top;
              " @click="copySome(scope.row.company_name)"></i></el-tooltip>
          <div style="font-size: 0.25rem; padding: 0.1rem">
            <p v-if="scope.row.date_of_est">
              成立日期：{{ scope.row.date_of_est.split(" ")[0] }}
            </p>
            <p v-if="scope.row.regStatus">企业状态：{{ scope.row.regStatus }}</p>
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="企业状态" width="100" prop="regStatus" fixed>
        <template slot-scope="scope">
          <el-tooltip :content="
            scope.row.annals_state.length > 0
              ? scope.row.annals_state[0].year
              : list_year
          " placement="top">
            <span class="hide-style">{{
              scope.row.annals_state.length > 0
              ? scope.row.annals_state[0].year
              : list_year
            }}</span>
          </el-tooltip>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="年份" width="60" fixed>
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.annals_state.length > 0
              ? scope.row.annals_state[0].year
              : list_year
              " placement="top">
              <span class="hide-style">{{
                scope.row.annals_state.length > 0
                ? scope.row.annals_state[0].year
                : list_year
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column> -->
      <el-table-column label="年报进度" width="100">
        <template slot-scope="scope">
          <div style="white-space: nowrap">
            <el-tooltip style="display: inline-block; vertical-align: middle" :content="scope.row.annals_state.length > 0
            ? scope.row.annals_state[0].status
            : '未通知'
          " placement="top">
              <span v-if="scope.row.annals_state.length > 0" class="hide-style">{{ scope.row.annals_state[0].status }}
              </span>
              <span v-else class="hide-style">未通知</span>
            </el-tooltip>
            <el-tooltip style="display: inline-block; vertical-align: middle; margin-left: 0.2rem"
              content="年报通知客户添加年报地址次数" placement="top" v-if="scope.row.annals_info.length &&
          scope.row.annals_state.length &&
          scope.row.annals_state[0].status === '已通知'
          ">
              <div style="
                  color: white;
                  display: inline-block;
                  background-color: #f56c6c;
                  border-radius: 100%;
                  width: 15px;
                  height: 15px;
                  text-align: center;
                  line-height: 15px;
                ">
                {{ scope.row.annals_info.length }}
              </div>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="是否完成年报" width="105">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.annals_overd.length > 0 ? '已完成' : '未完成'" placement="top">
            <span v-if="scope.row.annals_overd.length > 0" class="hide-style" style="color: #67c23a">{{
          scope.row.annals_overd.length > 0 ? "已完成" : "未完成" }}</span>
            <span v-else class="hide-style" style="color: red">{{
          scope.row.annals_overd.length > 0 ? "已完成" : "未完成"
        }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="已完成年报年份" width="120">
        <template slot-scope="scope">
          <div v-for="item in scope.row.annual_history.slice(0, 4)" :key="item.id">
            <el-tooltip :content="`年报公示日期${item.doned_at}`" placement="top" style="text-align: center">
              <p :class="item.year === list_year ? 'current-year' : 'other-year'">
                {{ item.year }}
              </p>
            </el-tooltip>
          </div>
          <div style="
              color: #409eff;
              text-align: center;
              font-size: xx-small;
              cursor: pointer;
            " v-if="scope.row.annual_history.length > 4 && !more_clicked[scope.row.id]"
            @click="showMore(scope.row.id)">
            更多...
          </div>
          <div v-if="more_clicked[scope.row.id]">
            <div v-for="item in scope.row.annual_history.slice(4)" :key="item.id">
              <el-tooltip :content="`年报公示日期${item.doned_at}`" placement="top" style="text-align: center">
                <p :class="item.year === list_year ? 'current-year' : 'other-year'">
                  {{ item.year }}
                </p>
              </el-tooltip>
            </div>
          </div>
          <div style="
              color: #409eff;
              text-align: center;
              font-size: xx-small;
              cursor: pointer;
            " v-if="more_clicked_close[scope.row.id]" @click="showMoreClose(scope.row.id)">
            收起
          </div>
        </template>
      </el-table-column>
      <el-table-column label="用户名称" width="120">
        <template slot-scope="scope">
          <!-- <el-tooltip
            :content="scope.row.user ? scope.row.user.name : ''"
            placement="top"
          >
            <span class="hide-style">{{
              scope.row.user ? scope.row.user.name : ""
            }}</span>
          </el-tooltip> -->
          <el-link type="primary" :underline="false" style="padding: 0; border: none" slot="reference"
            @click="handleShowPayerContent(scope.row)">{{ scope.row.user ? scope.row.user.name : "" }}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="是否关注公众号" width="120">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.oauth
            ? scope.row.oauth.subscribe === 1
              ? '已关注'
              : '未关注'
            : '未关注'
          " placement="top">
            <span class="hide-style">{{
          scope.row.oauth
            ? scope.row.oauth.subscribe === 1
              ? "已关注"
              : "未关注"
            : "未关注"
        }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="代账软件" width="120">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.com_fiscal_tax
            ? scope.row.com_fiscal_tax.software_types
              ? scope.row.com_fiscal_tax.software_types === 1
                ? '17DZ'
                : scope.row.com_fiscal_tax.software_types === 2
                  ? '云账房'
                  : scope.row.com_fiscal_tax.software_types === 3
                    ? '易代账'
                    : '其他'
              : '未知'
            : '无服务'
          " placement="top">
            <span class="hide-style">{{
          scope.row.com_fiscal_tax
            ? scope.row.com_fiscal_tax.software_types
              ? scope.row.com_fiscal_tax.software_types === 1
                ? "17DZ"
                : scope.row.com_fiscal_tax.software_types === 2
                  ? "云账房"
                  : scope.row.com_fiscal_tax.software_types === 3
                    ? "易代账"
                    : "其他"
              : "未知"
            : "无服务"
        }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="state.is_confirm" label="提醒企业添加地址信息/提醒人员" width="250">
        <template slot-scope="scope">
          <div style="display: flex; align-items: center">
            <el-tooltip content="提醒企业添加地址信息" placement="top">
              <el-button type="warning" size="mini" icon="el-icon-bell"
                @click="handleInformAdd(scope.row, scope.$index)" circle></el-button>
            </el-tooltip>
            <el-avatar v-if="scope.row.annals_info.length > 0"
              style="margin-right: 0.2rem; width: 28px; height: 28px; margin-left: 0.2rem" :src="scope.row.annals_info.length > 0
            ? imgPath + scope.row.annals_info[0].admin.buphoto
            : ''
          ">
            </el-avatar>
            <el-tooltip :content="scope.row.annals_info.length > 0
            ? scope.row.annals_info[0].admin.username +
            ' ' +
            scope.row.annals_info[0].created_at
            : ''
          " placement="top">
              <div style="color: #409eff; cursor: pointer" @click="handleOpen(scope.row, scope.$index)">
                <span class="hide-style" style="font-size: 0.25rem">
                  {{
          scope.row.annals_info.length > 0
            ? scope.row.annals_info[0].admin.username
            : ""
        }}
                </span>
                <span class="hide-style" style="font-size: 0.25rem" v-if="scope.row.annals_info.length > 0">
                  <!-- {{
                      scope.row.annals_info.length > 0
                      ? scope.row.annals_info[0].created_at
                      : ""
                    }} -->
                  <date-formatter :date-value="scope.row.annals_info[0].created_at"></date-formatter>
                </span>
                <span v-else></span>
              </div>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="state.is_confirm" label="信息提交人员" width="140">
        <template slot-scope="scope">
          <el-tooltip :content="scope.row.annals_form.length > 0
            ? (scope.row.annals_form[0].user
              ? scope.row.annals_form[0].user.username
              : scope.row.annals_form[0].admin
                ? scope.row.annals_form[0].admin.username
                : '') +
            ' ' +
            scope.row.annals_form[0].created_at
            : ''
          " placement="top">
            <div style="color: #409eff; cursor: pointer" @click="handleOpen(scope.row, scope.$index)">
              <span class="hide-style" style="font-size: 0.25rem">
                {{
          scope.row.annals_form.length > 0
            ? scope.row.annals_form[0].user
              ? scope.row.annals_form[0].user.username
              : scope.row.annals_form[0].admin
                ? scope.row.annals_form[0].admin.username
                : ""
            : ""
        }}
              </span>
              <span class="hide-style" style="font-size: 0.25rem" v-if="scope.row.annals_form.length > 0">
                <!-- {{
                    scope.row.annals_form.length > 0
                    ? scope.row.annals_form[0].created_at
                    : ""
                  }} -->
                <date-formatter :date-value="scope.row.annals_form[0].created_at"></date-formatter>
              </span>
              <span v-else></span>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="年报上报/年报上报人员" width="260">
        <template slot-scope="scope">
          <div style="display: flex; align-items: center">
            <el-tooltip content="上传图片" placement="top" v-if="scope.row.annals_upload.length <= 0">
              <el-button type="success" size="mini" icon="el-icon-upload2"
                @click="handleUploadImg(scope.row, scope.$index)" circle></el-button>
            </el-tooltip>
            <el-tooltip content="查看图片" placement="top" v-if="scope.row.annals_upload.length > 0">
              <el-button type="primary" size="mini" @click="handleOpen(scope.row, scope.$index)"
                icon="el-icon-picture-outline" circle></el-button>
            </el-tooltip>
            <el-avatar v-if="scope.row.annals_upload.length > 0"
              style="margin-right: 0.2rem; width: 28px; height: 28px; margin-left: 0.2rem" :src="scope.row.annals_upload.length > 0
            ? imgPath + scope.row.annals_upload[0].admin.buphoto
            : scope.row.annals_upload[0]
              ? imgPath + scope.row.annals_upload[0].admin.buphoto
              : ''
          ">
            </el-avatar>
            <el-tooltip :content="scope.row.annals_upload.length > 0
            ? scope.row.annals_upload[0].admin.username +
            ' ' +
            scope.row.annals_upload[0].created_at
            : ''
          " placement="top">
              <div>
                <span class="hide-style" style="font-size: 0.25rem">
                  {{
          scope.row.annals_upload.length > 0
            ? scope.row.annals_upload[0].admin.username
            : ""
        }}
                </span>
                <span class="hide-style" style="font-size: 0.25rem" v-if="scope.row.annals_upload.length > 0">
                  <!-- {{
                      scope.row.annals_upload.length > 0
                      ? scope.row.annals_upload[0].created_at
                      : ""
                    }} -->
                  <date-formatter :date-value="scope.row.annals_upload[0].created_at"></date-formatter>
                </span>
                <span v-else></span>
              </div>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="年报完成时间" width="120">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.annals_overd.length > 0 && !scope.row.annals_overd[0].date" :content="scope.row.annals_overd.length > 0
            ? scope.row.annals_overd[0].created_at
            : ''
          " placement="top">
            <span class="hide-style">{{
          scope.row.annals_overd.length > 0
            ? scope.row.annals_overd[0].created_at
            : ""
        }}</span>
          </el-tooltip>
          <el-tooltip v-if="scope.row.annals_overd.length > 0 && scope.row.annals_overd[0].date" :content="scope.row.annals_overd.length > 0 ? scope.row.annals_overd[0].date : ''
          " placement="top">
            <!-- <span class="hide-style">{{
                scope.row.annals_overd.length > 0
                ? scope.row.annals_overd[0].date
                : ""
              }}</span> -->
            <date-formatter :date-value="scope.row.annals_overd[0].date"></date-formatter>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="客户联系方式" width="290" prop="annual_phone">
        <template slot-scope="scope">
          <div style="display: flex; flex-direction: column">
            <div style="display: flex">
              <div style="text-align: right; width: 105px">服务对接人号码:</div>
              <div style="margin-left: 0.2rem; width: 150px; text-align: center" v-if="scope.row.docking_phone">
                <i>{{
                  showPhoneOrNotStatus === scope.row.id
                    ? scope.row.docking_phone
                    : doHiddenedPhone(scope.row.docking_phone)
                }}</i>
                <i
                  class="el-icon-view"
                  style="cursor: pointer; color: #409eff"
                  @click="showPhoneOrNot(scope.row.id)"
                ></i>
                <!-- <phone-com :comPhone="scope.row.docking_phone" :vagaryPhone="scope.row.vagary_phone"
                  style="display: inline-block" /> -->
                <el-tooltip content="同步为年报手机号" placement="top" v-if="!hasProperty(scope.row.user)">
                  <i class="el-icon-s-promotion" style="cursor: pointer; color: #409eff" @click="
          setToAnnualPhone(
            scope.row.user,
            scope.row.docking_phone,
            scope.row.id
          )
          "></i>
                </el-tooltip>
              </div>
            </div>
            <div style="display: flex">
              <div style="text-align: right; width: 105px">会员号码:</div>
              <div style="margin-left: 0.2rem; width: 150px; text-align: center"
                v-if="scope.row.user && scope.row.user.phone">
                <i>{{
                  showPhoneOrNotStatusMember === scope.row.id
                    ? scope.row.user.phone
                    : doHiddenedPhone(scope.row.user.phone)
                }}</i>
                <i
                  class="el-icon-view"
                  style="cursor: pointer; color: #409eff"
                  @click="showPhoneOrNotMember(scope.row.id)"
                ></i>
                <!-- <phone-com :comPhone="scope.row.user.phone" :vagaryPhone="scope.row.user.vagary_phone"
                  style="display: inline-block" /> -->
                <el-tooltip content="同步为年报手机号" placement="top" v-if="!hasProperty(scope.row.user)">
                  <i class="el-icon-s-promotion" style="cursor: pointer; color: #409eff" @click="
          setToAnnualPhone(scope.row.user, scope.row.user.phone, scope.row.id)
          "></i>
                </el-tooltip>
              </div>
            </div>
            <div style="display: flex">
              <div style="text-align: right; width: 105px">下单号码:</div>
              <div style="margin-left: 0.2rem; width: 150px; text-align: center"
                v-if="getCustomerAndCorporatePhone(scope.row.orders)[0].length === 1">
                <i>{{
                  showPhoneOrNotStatusCustomer === scope.row.id
                    ? getCustomerAndCorporatePhone(scope.row.orders)[0][0]
                    : doHiddenedPhone(
                        getCustomerAndCorporatePhone(scope.row.orders)[0][0]
                      )
                }}</i>
                <i
                  class="el-icon-view"
                  style="cursor: pointer; color: #409eff"
                  @click="
                    showPhoneOrNotCommon(scope.row.id, 'showPhoneOrNotStatusCustomer')
                  "
                ></i>
                <!-- <phone-com :comPhone="getCustomerAndCorporatePhoneHide(scope.row.orders)[0][0][a]"
                  :vagaryPhone="getCustomerAndCorporatePhoneHide(scope.row.orders)[0][0][b]"
                  style="display: inline-block" /> -->
                <el-tooltip content="同步为年报手机号" placement="top" v-if="!hasProperty(scope.row.user)">
                  <i class="el-icon-s-promotion" style="cursor: pointer; color: #409eff" @click="
          setToAnnualPhone(
            scope.row.user,
            getCustomerAndCorporatePhone(scope.row.orders)[0][0],
            scope.row.id
          )
          "></i>
                </el-tooltip>
              </div>
              <div style="margin-left: 0.2rem; width: 150px; text-align: center"
                v-if="getCustomerAndCorporatePhone(scope.row.orders)[0].length > 1">
                <i><el-link type="primary" @click="
          openCustomerDialog(
            getCustomerAndCorporatePhone(scope.row.orders)[0],
            // getCustomerAndCorporatePhoneHide(scope.row.orders)[0],
            scope.row.user,
            scope.row.id,
            '下单号码'
          )
          ">多个号码,点击查看</el-link></i>
              </div>
            </div>
            <div style="display: flex">
              <div style="text-align: right; width: 105px">法人号码:</div>
              <div style="margin-left: 0.2rem; width: 150px; text-align: center"
                v-if="getCustomerAndCorporatePhone(scope.row.orders)[1].length === 1">
                <i>{{
          showPhoneOrNotStatusCorporate === scope.row.id
            ? getCustomerAndCorporatePhone(scope.row.orders)[1][0]
            : doHiddenedPhone(
              getCustomerAndCorporatePhone(scope.row.orders)[1][0]
            )
        }}</i>
                <i class="el-icon-view" style="cursor: pointer; color: #409eff" @click="
        showPhoneOrNotCommon(scope.row.id, 'showPhoneOrNotStatusCorporate')
          "></i>
                <el-tooltip content="同步为年报手机号" placement="top" v-if="!hasProperty(scope.row.user)">
                  <i class="el-icon-s-promotion" style="cursor: pointer; color: #409eff" @click="
          setToAnnualPhone(
            scope.row.user,
            getCustomerAndCorporatePhone(scope.row.orders)[1][0],
            scope.row.id
          )
          "></i>
                </el-tooltip>
              </div>
              <div style="margin-left: 0.2rem; width: 150px; text-align: center"
                v-if="getCustomerAndCorporatePhone(scope.row.orders)[1].length > 1">
                <i><el-link type="primary" @click="
          openCustomerDialog(
            getCustomerAndCorporatePhone(scope.row.orders)[1],
            scope.row.user,
            scope.row.id,
            '法人号码'
          )
          ">多个号码,点击查看</el-link></i>
              </div>
            </div>
            <div style="display: flex">
              <div style="text-align: right; width: 105px">年报手机号码:</div>
              <div v-if="!needEditStatus[scope.row.id]">
                <div style="margin-left: 0.2rem; width: 150px; text-align: center" v-if="hasProperty(scope.row.user)">
                  <i @dblclick="toEdit(scope.row.user, scope.row.id)">{{
          showPhoneOrNotStatusAnnual === scope.row.id
            ? scope.row.user.client.annual_phone.annual_phone
            : doHiddenedPhone(scope.row.user.client.annual_phone.annual_phone)
        }}</i>
                  <i class="el-icon-view" style="cursor: pointer; color: #409eff"
                    @click="showPhoneOrNotAnnual(scope.row.id)"></i>
                </div>
                <div v-else style="margin-left: 0.2rem; width: 130px; text-align: center">
                  <i @dblclick="toEdit(scope.row.user, scope.row.id)">---</i>
                </div>
              </div>
              <edit-annualphone v-if="needEditStatus[scope.row.id] === true" :user_id="needUserId"
                @updatePrice="doUpdatePrice" @revert="revert" />
            </div>
          </div>
          <!-- <el-tooltip content="双击修改" placement="top" v-if="!needEditStatus[scope.row.id]">
              <span @dblclick="toEdit(scope.row.user, scope.row.id)" class="hide-style" v-if="scope.row.user">{{
                hasProperty(scope.row.user) ? doHiddenedPhone(scope.row.user.client.annual_phone.annual_phone) : '---'
              }}</span>
            </el-tooltip>
            <el-tag v-if="!scope.row.user" size="mini" type="danger" effect="dark">公司未关联客户</el-tag> -->
          <!-- <edit-annualphone v-if="needEditStatus[scope.row.id] === true" :user_id="needUserId"
              @updatePrice="doUpdatePrice" @revert="revert" /> -->
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="70">
        <template slot-scope="scope">
          <!-- <el-tooltip class="item" effect="dark" content="年报地址信息" placement="top">
              <el-button type="primary" size="mini" icon="el-icon-edit-outline"
                @click="handleAddAddress(scope.row, scope.$index)" :disabled="scope.row.annals_form.length > 0"
                circle></el-button>
            </el-tooltip> -->
          <!-- <el-tooltip class="item" effect="dark" content="财税建议" placement="top">
              <el-button type="primary" @click="handleOpenAdvice(scope.row.id, scope.row.company_name)" size="mini"
                icon="el-icon-reading" circle></el-button>
            </el-tooltip> -->
          <!-- <el-tooltip class="item" effect="dark" content="聊天记录" placement="top">
              <el-button type="primary" :disabled="scope.row.chat_com ? false : true" @click="
                handleChatOpen(scope.row.chat_com, scope.row.company_name)
                " size="mini" icon="el-icon-s-comment" circle></el-button>
            </el-tooltip> -->
          <!-- <el-tooltip class="item" effect="dark" content="企业微信群聊天记录" placement="top">
              <el-button type="warning" :disabled="scope.row.wx_work_chat_com ? false : true" @click="
                handleWxChatOpen(
                  scope.row.wx_work_chat_com,
                  scope.row.company_name
                )
                " size="mini" icon="el-icon-s-comment" circle></el-button>
            </el-tooltip> -->
          <!-- <el-tooltip class="item" effect="dark" content="企友聊天记录" placement="top">
              <el-button type="success" :disabled="scope.row.qy_chat_com ? false : true" size="mini"
                icon="el-icon-s-comment" @click="
                  handleQyChatOpen(scope.row.qy_chat_com, scope.row.company_name)
                  " circle></el-button>
            </el-tooltip> -->
          <!-- <el-tooltip class="item" effect="dark" content="电话联系记录" placement="top">
              <el-button type="primary" size="mini" icon="el-icon-phone-outline
      " :disabled="scope.row.user ? false : true" circle @click="handCallLogsOpen(scope.row)"></el-button>
            </el-tooltip> -->
          <el-dropdown>
            <span class="el-dropdown-link">
              更多<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-tooltip class="item" effect="dark" content="年报地址信息" placement="top">
                  <el-button type="primary" size="mini" icon="el-icon-edit-outline"
                    @click="handleAddAddress(scope.row, scope.$index)"
                    :disabled="scope.row.annals_form.length > 0">年报地址信息&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
                </el-tooltip>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-tooltip class="item" effect="dark" content="财税建议" placement="top">
                  <el-button type="primary" @click="handleOpenAdvice(scope.row.id, scope.row.company_name)" size="mini"
                    icon="el-icon-reading">财税建议&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
                </el-tooltip>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-tooltip class="item" effect="dark" content="聊天记录" placement="top">
                  <el-button type="primary" :disabled="scope.row.chat_com ? false : true"
                    @click="handleChatOpen(scope.row.chat_com, scope.row.company_name)" size="mini"
                    icon="el-icon-s-comment">聊天记录&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
                </el-tooltip>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-tooltip class="item" effect="dark" content="企业微信群聊天记录" placement="top">
                  <el-button type="warning" :disabled="scope.row.wx_work_chat_com ? false : true" @click="
          handleWxChatOpen(scope.row.wx_work_chat_com, scope.row.company_name)
          " size="mini" icon="el-icon-s-comment">企业微信群聊天记录</el-button>
                </el-tooltip>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-tooltip class="item" effect="dark" content="企友聊天记录" placement="top">
                  <el-button type="success" :disabled="scope.row.qy_chat_com ? false : true" size="mini"
                    icon="el-icon-s-comment" @click="
          handleQyChatOpen(scope.row.qy_chat_com, scope.row.company_name)
          ">企友聊天记录&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
                </el-tooltip>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-tooltip class="item" effect="dark" content="电话联系记录" placement="top">
                  <el-button type="primary" size="mini" icon="el-icon-phone-outline
      " :disabled="scope.row.user ? false : true"
                    @click="handCallLogsOpen(scope.row)">电话联系记录&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button>
                </el-tooltip>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background class="text-r mt-10" layout="total, sizes, prev, pager, next, jumper"
      :hide-on-single-page="false" :current-page="pageOption.currentPage" :page-sizes="pageOption.pageSizes"
      :page-size="pageOption.pageSize" :total="pageOption.total" @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
    <!-- </el-main> -->
    <el-drawer title="财税建议" :visible.sync="categoryIndrawer" direction="rtl" :before-close="handleCloseIn" size="50%">
      <div style="padding: 0.2em 1.4em; margin-top: -10px">
        <tax-advice :comId="adviceComId" :comName="adviceComName"></tax-advice>
      </div>
    </el-drawer>
    <el-drawer :title="'年报申报成功截图【' + companyName + '】'" :visible.sync="uploadingDrawer" :before-close="handleAddClose"
      size="40%">
      <div class="drawer-content">
        <el-form :model="addForm" ref="addForm" label-width="100px" size="mini">
          <el-row>
            <el-col :span="24">
              <el-form-item label="年份" prop="month">
                <el-date-picker v-model="addForm.year" type="year" size="mini" width="100%" readonly format="yyyy 年"
                  value-format="yyyy" @change="pickerDataChangeUpload" placeholder="选择月">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="备注" prop="user_remark">
            <el-input v-model="addForm.remark" type="textarea" placeholder="请输入需要告知客户的信息(若无 可不填写)" />
          </el-form-item>
        </el-form>
        <el-row>
          <el-col :span="24">
            <el-card shadow="hover">
              <el-upload multiple ref="upload" action="#" accept="image/png, image/jpeg, image/gif" :limit="5"
                :on-preview="handleLicensePreview" :on-change="handleLicenseChange" :on-remove="handleLicenseRemove"
                :file-list="licenseList" list-type="picture" :auto-upload="false">
                <el-link slot="trigger" type="primary">上传截图(最多可上传5张)</el-link>
              </el-upload>
            </el-card>
          </el-col>
        </el-row>
        <el-row class="mt-10">
          <el-input v-paste="handleParse" type="textarea" placeholder="请点击此处，再粘贴复制的截图" />
        </el-row>
        <el-row class="mt-10">
          <el-col :span="24" class="text-r">
            <el-button type="primary" size="mini" @click="submitAddUpload('addForm')">添加</el-button>
          </el-col>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer :title="'年报信息【' + addressForm.cname + '】'" :visible.sync="formDrawer" direction="rtl" size="35%"
      fullscreen>
      <div style="margin-left: 0.4rem">
        <div class="m-tabs-content">
          <div class="blocka">
            <el-tabs v-model="showTabPane" type="border-card">
              <el-tab-pane label="年报地址" name="first">
                <div class="tabs_line">
                  <div class="lines"></div>
                  <h3 class="tabs-title">年报地址信息</h3>
                </div>
                <el-divider></el-divider>
                <el-row>
                  <el-col :span="24" class="m-label">
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="公司名称" placement="top">
                        <span class="count_style" style="display: inherit">公司名称：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-col :span="20">
                        <el-input v-model="addressForm.cname" size="mini" type="text" disabled />
                      </el-col>
                    </el-col>
                  </el-col>
                  <el-col :span="24">
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="年报年份" placement="top">
                        <span class="count_style" style="display: inherit">年报年份：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-col :span="20">
                        <el-date-picker v-model="addressForm.year" type="year" size="mini" format="yyyy 年"
                          :picker-options="pickerOptions" value-format="yyyy" placeholder="选择年">
                        </el-date-picker>
                      </el-col>
                    </el-col>
                  </el-col>
                  <el-col :span="24" class="m-label">
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="客户姓名" placement="top">
                        <span class="count_style" style="display: inherit">客户姓名：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-col :span="20">
                        <el-input v-model="addressForm.legaler" size="mini" type="text" placeholder="请输入客户姓名" />
                      </el-col>
                    </el-col>
                  </el-col>
                  <el-col :span="24" class="m-label">
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="客户手机" placement="top">
                        <span class="count_style" style="display: inherit">客户手机：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-col :span="20">
                        <el-input v-model="addressForm.phone" size="mini" type="text" placeholder="请输入客户手机" />
                      </el-col>
                    </el-col>
                  </el-col>
                  <el-col :span="24" class="m-label">
                    <el-col :span="4" class="m-label">
                      <el-tooltip content="公司实际地址" placement="top">
                        <span class="count_style" style="display: inherit">公司地址：</span>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="20" class="m-label">
                      <el-col :span="20">
                        <el-input v-model="addressForm.address" type="textarea" placeholder="请输入公司实际经营地址" />
                      </el-col>
                    </el-col>
                  </el-col>
                </el-row>
                <el-row class="m-label">
                  <el-col :span="21" class="text-r">
                    <el-button type="primary" size="mini" @click="handleAddAddressForm">添加</el-button>
                  </el-col>
                  <el-col style="height: 50px"></el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-drawer :title="'服务详情【' + companyName + '】'" :visible.sync="serviceDrawer" direction="rtl" size="45%" fullscreen
      @close="closeThis">
      <div style="margin-left: 0.4rem">
        <div class="m-tabs-content">
          <div class="blocka">
            <el-tabs v-model="showTabPane" type="border-card" @tab-click="handle_tabChange">
              <el-tab-pane label="服务记录" name="first">
                <el-collapse v-model="activeName" v-for="(records, index) in infoRecord" :key="index" accordion
                  style="border-bottom: 1px solid #ebeef5">
                  <el-collapse-item :title="records.year + ' 年企业年报服务详情'" :name="index + 1">
                    <el-timeline>
                      <el-timeline-item :timestamp="item.created_at" v-for="(item, index) in records.record"
                        :key="index" placement="top">
                        <el-card>
                          <h4>
                            <el-row>
                              <el-col :span="20">
                                {{
          (item.admin
            ? item.admin.username
            : item.user
              ? item.user.usernames
              : "") +
          (item.type === 2
            ? "提醒了客户"
            : item.type === 3
              ? "提交了年报信息"
              : item.type === 4
                ? "上传了年报申报截图"
                : item.type === 5
                  ? "年报完成"
                  : "")
        }}
                              </el-col>
                              <el-col :span="4" v-if="item.type === 3">
                                <span><el-button type="primary" size="mini" style="float: right"
                                    @click="handleSureChange(item)">{{ buttonText }}</el-button></span>
                              </el-col>
                            </el-row>
                          </h4>
                          <span v-if="item.images">
                            <span v-for="(imgUrl, index) in item.images" :key="index">
                              <el-image class="image" :src="imgUrl" :preview-src-list="item.images" v-if="item.images"
                                style="margin-right: 0.1rem"></el-image>
                            </span>
                          </span>
                          <span v-if="item.type === 3">
                            <el-row>
                              <el-col :span="24" class="m-label">
                                <el-col :span="4" class="m-label">
                                  <el-tooltip content="公司名称" placement="top">
                                    <span class="count_style" style="display: inherit">公司名称：</span>
                                  </el-tooltip>
                                </el-col>
                                <el-col :span="20" class="m-label">
                                  <el-col :span="20">
                                    <span>{{ item.remark.cname }}</span>
                                  </el-col>
                                </el-col>
                              </el-col>
                              <el-col :span="24">
                                <el-col :span="4" class="m-label">
                                  <el-tooltip content="年报年份" placement="top">
                                    <span class="count_style" style="display: inherit">年报年份：</span>
                                  </el-tooltip>
                                </el-col>
                                <el-col :span="20" class="m-label">
                                  <el-col :span="20">
                                    <span>{{ item.remark.year + " 年" }}</span>
                                  </el-col>
                                </el-col>
                              </el-col>

                              <el-col v-if="isShowEdit === true">
                                <el-col :span="24" class="m-label">
                                  <el-col :span="4" class="m-label">
                                    <el-tooltip content="客户姓名" placement="top">
                                      <span class="count_style" style="display: inherit">客户姓名：</span>
                                    </el-tooltip>
                                  </el-col>
                                  <el-col :span="20" class="m-label">
                                    <el-col :span="20">
                                      <el-input v-model="editData.legaler" size="mini" type="text"
                                        @change="handleEditRemarkMsg(item.id, 'legaler')" placeholder="请输入客户姓名" />
                                    </el-col>
                                  </el-col>
                                </el-col>
                                <el-col :span="24" class="m-label">
                                  <el-col :span="4" class="m-label">
                                    <el-tooltip content="客户手机" placement="top">
                                      <span class="count_style" style="display: inherit">客户手机：</span>
                                    </el-tooltip>
                                  </el-col>
                                  <el-col :span="20" class="m-label">
                                    <el-col :span="20">
                                      <el-input v-model="editData.phone" size="mini" type="text"
                                        @change="handleEditRemarkMsg(item.id, 'phone')" placeholder="请输入客户手机" />
                                    </el-col>
                                  </el-col>
                                </el-col>
                                <el-col :span="24" class="m-label">
                                  <el-col :span="4" class="m-label">
                                    <el-tooltip content="公司实际地址" placement="top">
                                      <span class="count_style" style="display: inherit">公司地址：</span>
                                    </el-tooltip>
                                  </el-col>
                                  <el-col :span="20" class="m-label">
                                    <el-col :span="20">
                                      <el-input v-model="editData.address" type="textarea"
                                        @change="handleEditRemarkMsg(item.id, 'address')" placeholder="请输入公司实际经营地址" />
                                    </el-col>
                                  </el-col>
                                </el-col>
                              </el-col>

                              <el-col v-if="isShowEdit === false">
                                <el-col :span="24" class="m-label">
                                  <el-col :span="4" class="m-label">
                                    <el-tooltip content="客户姓名" placement="top">
                                      <span class="count_style" style="display: inherit">客户姓名：</span>
                                    </el-tooltip>
                                  </el-col>
                                  <el-col :span="20" class="m-label">
                                    <el-col :span="20">
                                      <span>{{ item.remark.legaler }}</span>
                                    </el-col>
                                  </el-col>
                                </el-col>
                                <el-col :span="24" class="m-label">
                                  <el-col :span="4" class="m-label">
                                    <el-tooltip content="客户手机" placement="top">
                                      <span class="count_style" style="display: inherit">客户手机：</span>
                                    </el-tooltip>
                                  </el-col>
                                  <el-col :span="20" class="m-label">
                                    <el-col :span="20">
                                      <span>{{ item.remark.phone }}</span>
                                    </el-col>
                                  </el-col>
                                </el-col>
                                <el-col :span="24" class="m-label">
                                  <el-col :span="4" class="m-label">
                                    <el-tooltip content="公司实际地址" placement="top">
                                      <span class="count_style" style="display: inherit">公司地址：</span>
                                    </el-tooltip>
                                  </el-col>
                                  <el-col :span="20" class="m-label">
                                    <el-col :span="20">
                                      <span>{{ item.remark.address }}</span>
                                    </el-col>
                                  </el-col>
                                </el-col>
                              </el-col>
                            </el-row>
                          </span>
                          <p v-if="item.remark && item.type !== 3">
                            {{ "备注：" + item.remark }}
                          </p>
                          <p v-if="!item.remark">备注：无</p>
                        </el-card>
                      </el-timeline-item>
                    </el-timeline>
                  </el-collapse-item>
                </el-collapse>
              </el-tab-pane>
              <el-tab-pane label="公司信息" name="second">
                <company-info :companyId="companyInfoId" @reloadTable="reloadTable"></company-info>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-drawer title="聊天记录" :visible.sync="chatDrawer" direction="rtl" :before-close="handleChatBeforeClose" size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <chat :chatId="chatId" :chatName="chatName"></chat>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="企业微信聊天记录" :visible.sync="wxChatDrawer" direction="rtl" :before-close="handleWxChatBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <wx-work-chat :chatId="wxWorkChatId" :chatName="wxWorkchatName"></wx-work-chat>
        </el-row>
      </div>
    </el-drawer>
    <el-dialog title="批量通知" :visible.sync="batchDialog" width="30%">
      <el-date-picker v-model="dateTime" type="year" size="mini" format="yyyy 年" value-format="yyyy"
        :picker-options="pickerOptions" placeholder="选择年份">
      </el-date-picker>
      <!-- <el-checkbox-group v-model="checkList">
        <div class="wrapper" style="display: flex;flex-wrap: wrap;gap: 8px;justify-content: flex-start;padding-top: 0.5rem;">
          <div class="phone-item">
            <el-checkbox :label="1">服务对接人号码</el-checkbox>
          </div>
          <div class="phone-item">
            <el-checkbox :label="2">会员号码</el-checkbox>
          </div>
          <div class="phone-item">
            <el-checkbox :label="3">下单号码</el-checkbox>
          </div>
          <div class="phone-item">
            <el-checkbox :label="4">法人号码</el-checkbox>
          </div>
          <div class="phone-item">
            <el-checkbox :label="5">年报手机号</el-checkbox>
          </div>
        </div>
      </el-checkbox-group> -->
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="batchDialog = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="batchSendInform">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择年份" :visible.sync="exportDialog" width="30%">
      <el-date-picker v-model="dateTimeExport" type="year" size="mini" format="yyyy 年" value-format="yyyy"
        :picker-options="pickerOptions" placeholder="选择年份">
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="exportDialog = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="doExport">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="" :visible.sync="customerPhoneDialog" width="30%" :before-close="handleCloseCustomerPhoneDialog">
      <template slot="title">
        <i style="font-size: larger; font-weight: bold">{{ dialogCustomerTitle }}</i>
      </template>
      <div style="
          text-align: center;
          font-size: large;
          background-color: #e6f3f9;
          border-radius: 3%;
          padding: 0.2rem 0;
          box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
        " v-for="item in dialogCustomerPhoneArr" :key="item">
        <i>{{ item }}</i>
        <!-- <phone-com :comPhone="item[0]" -->
          <!-- :vagaryPhone="item[1]" style="display: inline-block" /> -->
        <el-tooltip content="同步为年报手机号" placement="top" v-if="!hasProperty(dialogCustomer)">
          <i class="el-icon-s-promotion" style="
              cursor: pointer;
              color: #409eff;
              margin-left: 0.2rem;
              margin-top: 0.2rem;
            " @click="setToAnnualPhone(dialogCustomer, item, dialogCustomerRowId)"></i>
        </el-tooltip>
      </div>
    </el-dialog>
    <el-drawer title="电话联系记录" :visible.sync="callLogsDrawer" direction="rtl" :before-close="handleCallLogsBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <call-logs :company="company" :phone="callPhone" :phone1="callPhone1" :phone2="callPhone2"
            :phone3="callPhone3"></call-logs>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="聊天记录" :visible.sync="qyChatDrawer" direction="rtl" :before-close="handleQyChatBeforeClose"
      size="50%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <qy-group-chat :chatId="qyChatId" :chatName="qyChatName"></qy-group-chat>
      </div>
    </el-drawer>
    <!-- 支付人详情及公司情况 开始 -->
    <el-drawer title="支付人详情及公司概况" :visible.sync="handlePayerContentDrawer" direction="rtl" :before-close="handleClose"
      size="50%" class="PayerContent">
      <!-- 组件调用 -->
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <userwith-order :PayerData="userData" :ThreadData="ThreadData" :PayerCompanyData="PayerCompanyData"
            :userOrderData="userOrderData"></userwith-order>
        </el-row>
      </div>
      <!-- 组件调用 -->
    </el-drawer>
    <!-- 支付人详情及公司情况 结束 -->
    <!-- 沟通记录弹窗 开始-->
    <el-drawer title="沟通记录" :visible.sync="chatRecordDrawer" direction="rtl" :before-close="handleChatRecordBeforeClose"
      size="40%">
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <chat-record :threadId="threadId"></chat-record>
        </el-row>
      </div>
    </el-drawer>
    <!-- 沟通记录弹窗 结束-->
    <!-- </el-container> -->
  </div>
</template>

<script>
import EditAnnualphone from "./Components/EditAnnualphone";
import Chat from "common/Chat";
import WxWorkChat from "common/WxWorkChat";
import CallLogs from "common/CallLogs";
import QyGroupChat from "common/QyGroupChat";
import TaxAdvice from "common/TaxAdvice";
import CompanyInfo from "common/CompanyInfo";
import UserwithOrder from "common/UserWithOrder";
import ChatRecord from "common/ChatRecord";
import DateFormatter from "common/DateFormatter";
import PhoneCom from "common/PhoneCom";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';

export default {
  name: "Annals",
  components: {
    Chat,
    WxWorkChat,
    CallLogs,
    QyGroupChat,
    TaxAdvice,
    CompanyInfo,
    UserwithOrder,
    ChatRecord,
    EditAnnualphone,
    DateFormatter,
    PhoneCom
  },
  data() {
    return {
      more_clicked: [],
      more_clicked_close: [],
      hyperfHost:
        process.env.NODE_ENV === "development"
          ? "http://127.0.0.1:9501"
          : "https://qyh-next-server.zhang66.cn",
      showPhoneOrNotStatus: null,
      showPhoneOrNotStatusMember: null,
      showPhoneOrNotStatusAnnual: null,
      showPhoneOrNotStatusCustomer: null,
      showPhoneOrNotStatusCorporate: null,
      needAnnualId: null,
      needUserId: null,
      needEditStatus: [],
      exportDialog: false,
      customerPhoneDialog: false,
      dialogCustomerPhoneArr: [],
      dialogCustomerRowId: null,
      dialogCustomerTitle: null,
      dialogCustomer: null,
      dateTimeExport: "",
      handlePayerContentDrawer: false,
      ThreadData: {},
      userData: {},
      // 客户线索沟通记录弹窗
      chatRecordDrawer: false,
      // 沟通子组件传递的线索id
      threadId: null,
      PayerCompanyData: [],
      userOrderData: [],
      payerShowTab: "1",
      companyInfoDrawer: false,
      secondTab_needId: "",
      companyInfoId: null,
      annalMore: [],
      formData: null,
      loading: false,
      serviceDrawer: false,
      batchDialog: false,
      searchVisible: false,
      formDrawer: false,
      isShowEdit: false,
      uploadingDrawer: false,
      showTabPane: "first",
      buttonText: "编辑信息",
      activeName: 1,
      list_year: "",
      dateTime: "",
      companyName: "",
      licenseList: [],
      allusers: [],
      companies: [],
      batchArr: [],
      infoRecord: [],
      adviceComId: null,
      adviceComName: null,
      categoryIndrawer: false,
      annals: [],
      options_base: [],
      options_real: [],
      options_company_status: [],
      searchArr: {
        companyStatus: "",
        base: "",
        real: "",
        regStatus: "",
        companyName: [],
        cid: '',
        dateTime: "",
        status: "",
        leader_id: "",
        acc_id: "",
        ass_id: "",
        saler_id: "",
        advisory_id: "",
        invoice_id: "",
        is_bind: "",
        is_subscribe: "",
        is_date_of_est: "1",
        date_of_est: "",
        archives: "",
        annual_phone: "",
      },
      checkList: [5],
      informForm: {
        cid: null,
        year: "",
      },
      addForm: {
        year: "",
        remark: "",
        cid: null,
        index: null,
      },
      addressForm: {
        cid: null,
        index: null,
        cname: "",
        year: "",
        phone: "",
        legaler: "",
        address: "",
      },
      editData: {
        field: "",
        legaler: "",
        phone: "",
        address: "",
      },
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        pageSize: 30, // 每页显示条数
        pageSizes: [10, 20, 30, 50, 100, 500],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 365 * 24 * 3600 * 1000;
        },
      },
      imgPath: "https://www.qiyehuo.com/uploads/adminuser/",
      chatDrawer: false,
      chatId: "",
      chatName: "",
      wxChatDrawer: false,
      wxWorkChatId: "",
      wxWorkchatName: "",
      callLogsDrawer: false,
      company: "",
      callPhone: [],
      callPhone1: [],
      callPhone2: [],
      callPhone3: [],
      qyChatDrawer: false,
      qyChatId: "",
      qyChatName: "",
      additionalData: { value: "无", label: "NULL" },
    };
  },
  computed: {
    pageData: function () {
      return this.annals;
    },
    searchStr: function () {
      let str = "";
      for (let key in this.searchArr) {
        str += "&" + key + "=" + this.searchArr[key];
      }

      return str;
    },
    collapse() {
      return this.$store.state.collapse;
    },
    allusersAddition() {
      return [...this.allusers, this.additionalData];
    },
  },
  methods: {
    doConfirm() {
      this.$axios.get("api/api3_annals/notice_add_annals_address_again").then((res) => {
        const { data } = res;
        if (data) {
          this.$message.success(data);
          var myEvent = new Event("click");
          document.dispatchEvent(myEvent);
        } else {
          this.$message.error("通知失败!");
        }
      });
    },
    showMore(id) {
      this.more_clicked = [];
      this.more_clicked.push(id);
      this.more_clicked[id] = true;
      this.more_clicked_close = [];
      this.more_clicked_close.push(id);
      this.more_clicked_close[id] = true;
    },
    showMoreClose(id) {
      this.more_clicked_close = [];
      this.more_clicked_close.push(id);
      this.more_clicked_close[id] = false;
      this.more_clicked = [];
      this.more_clicked.push(id);
      this.more_clicked[id] = false;
    },
    clearAnnualPhone() {
      this.searchArr.annual_phone = "";
    },
    toEdit(user, id) {
      this.needAnnualId = id;
      this.needEditStatus = [];
      this.needEditStatus.push(id);
      this.needEditStatus[id] = true;
      this.$nextTick(() => {
        this.needUserId = user.id;
      });
    },
    doUpdatePrice(phone) {
      this.needEditStatus = [];
      this.pageData.map((item) => {
        if (item.id === this.needAnnualId) {
          Object.assign(item.user, { client: {} });
          Object.assign(item.user.client, { annual_phone: {} });
          Object.assign(item.user.client.annual_phone, { annual_phone: phone });
        }
      });
    },
    revert() {
      this.needEditStatus = [];
    },
    hasProperty(obj) {
      if (obj && obj.client) {
        if (obj.client.annual_phone) {
          return true;
        }
      } else {
        return false;
      }
    },
    doHiddenedPhone(phone) {
      return phone.substring(0, 2) + "*****" + phone.substring(7);
    },
    showPhoneOrNot(id) {
      this.showPhoneOrNotStatus === id
        ? (this.showPhoneOrNotStatus = null)
        : (this.showPhoneOrNotStatus = id);
    },
    showPhoneOrNotMember(id) {
      this.showPhoneOrNotStatusMember === id
        ? (this.showPhoneOrNotStatusMember = null)
        : (this.showPhoneOrNotStatusMember = id);
    },
    showPhoneOrNotAnnual(id) {
      this.showPhoneOrNotStatusAnnual === id
        ? (this.showPhoneOrNotStatusAnnual = null)
        : (this.showPhoneOrNotStatusAnnual = id);
    },
    showPhoneOrNotCommon(id, f) {
      this[f] === id ? (this[f] = null) : (this[f] = id);
    },
    setToAnnualPhone(user, phone, table_data_id) {
      if (!user) {
        this.$message.warning("公司未关联客户!");
        return false;
      }
      this.$axios
        .post("api/annual/set_became_to_annual_phone", {
          user_id: user.id,
          phone,
        })
        .then(({ data }) => {
          if (data.code === 200) {
            this.pageData.map((item) => {
              if (item.id === table_data_id) {
                Object.assign(item.user, { client: {} });
                Object.assign(item.user.client, { annual_phone: {} });
                Object.assign(item.user.client.annual_phone, { annual_phone: phone });
              }
            });
            this.customerPhoneDialog = false;
          }
        });
    },
    getCustomerAndCorporatePhone(order) {
      let customer_phone_arr = [];
      let corporate_phone_arr = [];
      order.map((item) => {
        if (item.customer_phone) customer_phone_arr.push(item.customer_phone);
        if (item.corporate_phone) corporate_phone_arr.push(item.corporate_phone);
      });
      customer_phone_arr = Array.from(new Set(customer_phone_arr));
      corporate_phone_arr = Array.from(new Set(corporate_phone_arr));
      return [customer_phone_arr, corporate_phone_arr];
    },
    getCustomerAndCorporatePhoneHide(order) {
      let customer_phone_arr = [];
      let corporate_phone_arr = [];
      order.map((item) => {
        if (item.customer_phone) {
          // customer_phone_arr.push(item.customer_phone);
          // customer_phone_arr.push(item.vagary_phone_custome);
          customer_phone_arr.push({
            a: item.customer_phone,
            b: item.vagary_phone_custome
          });
        }
        if (item.corporate_phone) {
          corporate_phone_arr.push(item.corporate_phone);
          corporate_phone_arr.push(item.vagary_phone_corporate);
        }
      });
      customer_phone_arr = Array.from(new Set(customer_phone_arr));
      corporate_phone_arr = Array.from(new Set(corporate_phone_arr));
      console.log([customer_phone_arr, corporate_phone_arr]);
      return [customer_phone_arr, corporate_phone_arr];
    },
    openCustomerDialog(phone_arr, customer, id, name) {
      // console.log(phone_arr)
      this.dialogCustomerPhoneArr = phone_arr;
      this.dialogCustomer = customer;
      this.dialogCustomerRowId = id;
      this.dialogCustomerTitle = name;
      this.customerPhoneDialog = true;
    },
    handleCloseCustomerPhoneDialog(done) {
      this.dialogCustomerPhoneArr = [];
      this.dialogCustomer = null;
      this.dialogCustomerRowId = null;
      this.dialogCustomerTitle = null;
      done();
    },
    // 复制功能
    copy(data) {
      // 存储传递过来的数据
      let OrderNumber = data;
      // 创建一个input 元素
      // createElement() 方法通过指定名称创建一个元素
      let newInput = document.createElement("input");
      // 讲存储的数据赋值给input的value值
      newInput.value = OrderNumber;
      // appendChild() 方法向节点添加最后一个子节点。
      document.body.appendChild(newInput);
      // 选中input元素中的文本
      // select() 方法用于选择该元素中的文本。
      newInput.select();
      // 执行浏览器复制命令
      //  execCommand方法是执行一个对当前文档，当前选择或者给出范围的命令
      document.execCommand("Copy");
      // 清空输入框
      newInput.remove();
      // 下面是element的弹窗 不需要的自行删除就好
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    copySome(data) {
      this.copy(data);
    },
    getCompanyStatus() {
      this.$axios
        .get("api/annals/get_company_status")
        .then(({ data }) => {
          if (data.code === 0) {
            this.options_company_status = data.data;
          }
        })
        .catch();
    },
    getBase() {
      this.$axios
        .get("api/annals/get_company_base")
        .then(({ data }) => {
          if (data.code === 0) {
            this.options_base = data.data;
          }
        })
        .catch();
    },
    getReal(val) {
      this.options_real = [];
      this.searchArr.real = "";
      this.$axios
        .get("api/annals/get_company_real", {
          params: {
            pid: val,
          },
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.options_real = data.data;
          }
        })
        .catch();
    },
    // 展示支付人信息及公司情况
    handleShowPayerContent(row) {
      this.ThreadData = row.user.publicthread;
      this.userData = row.user;
      this.PayerCompanyData = row.user.company;
      if (this.PayerCompanyData.length !== 0) {
        for (let item of this.PayerCompanyData) {
          item.business_man = row.user.business.username;
        }
      }
      this.handelOpenUserOrder(row.user);
      this.handlePayerContentDrawer = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.PayerData = [];
          this.handlePayerContentDrawer = false;
          this.payerShowTab = "1";
          done();
        })
        .catch((_) => { });
    },
    // 控制用户关联订单信息展示与隐藏
    handelOpenUserOrder(row) {
      this.$axios.post("/api/customer/get_customer_order", { id: row.id }).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.userOrderData = data.data;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    // 打开当前客户手机号对应的沟通记录
    handleShowChatRecordOpen(threadId) {
      this.chatRecordDrawer = true;
      setTimeout(() => {
        this.threadId = threadId;
      });
    },
    // 关闭沟通记录弹窗
    handleChatRecordBeforeClose(done) {
      this.chatRecordDrawer = false;
      this.threadId = null;
      done();
    },
    closeThis() {
      this.secondTab_needId = "";
    },
    reloadTable() {
      this.getPageDatas();
    },
    handle_tabChange(tab) {
      if (tab.name === "second") {
        setTimeout(() => {
          this.companyInfoId = this.secondTab_needId;
        });
      }
    },
    findUpdate(companyNameArr) {
      this.pageOption.currentPage = 1;
      this.searchArr.companyName = companyNameArr;
      this.getPageDatas();
    },
    updateAnnal() {
      if (this.annalMore.length === 0) {
        this.$message.warning("请先批量勾选！");
        return false;
      }
      this.$axios
        .get("api/annals/annals_xlb?ids=" + this.annalMore)
        .then(({ data }) => {
          if (data.code === 1) {
            let _this = this;
            this.$notify.info({
              title: "本次共更新了" + data.num + "条数据",
              dangerouslyUseHTMLString: true,
              message: data.companys.join(","),
              duration: 0,
              onClick() {
                _this.findUpdate(data.companys);
              },
              // onClose () {
              //   _this.getPageDatas()
              // }
            });
            // this.getPageDatas()
            if (data.companys.length > 0) this.findUpdate(data.companys);
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    getIdForAnnal(val) {
      let ids = val.map((i) => {
        return i.id;
      });
      this.annalMore = ids;
    },
    getPageDatas() {
      this.$axios
        .get(
          "/api/annals?page=" +
          this.pageOption.currentPage +
          "&limit=" +
          this.pageOption.pageSize +
          this.searchStr
        )
        .then((res) => {
          const { data } = res;
          this.annals = data.data.list.data;
          this.list_year = data.data.year;
          this.allusers = data.data.users;
          this.pageOption.total = data.data.list.total;
          this.pageOption.currentPage = data.data.list.current_page;
          this.batchArr = [];
          this.searchArr.companyName = [];
          for (let key in this.annals) {
            this.batchArr.push(this.annals[key].id);
          }
        });
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.getPageDatas();
    },
    handleCloseIn(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          setTimeout(() => {
            this.adviceComId = null;
            // this.$refs.categoryForm.resetFields()
            // this.$refs.uploadMutiple.clearFiles()
            this.needUrl = [];
          });
          done();
        })
        .catch((_) => { });
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.getPageDatas();
    },
    handleInformAdd(row, index) {
      this.informForm.cid = row.id;
      this.informForm.year = this.list_year;
      this.$axios.post("/api/annals/inform", this.informForm).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          if (data.data.stateRow && !Array.isArray(data.data.stateRow)) {
            this.annals[index].annals_state.unshift(data.data.stateRow);
          }
          this.annals[index].annals_info.unshift(data.data.record);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleUploadImg(row, index) {
      if (row.annals_form.length <= 0) {
        this.$message.error("请提交客户年报地址信息");
        return;
      }
      this.companyName = row.company_name;
      this.addForm.index = index;
      this.addForm.cid = row.id;
      this.addForm.year = this.list_year;
      this.licenseList = [];
      this.formData = null;
      this.formData = new FormData();
      this.uploadingDrawer = true;
    },
    handleLicensePreview(file) { },
    handleLicenseChange(file, fileList) {
      this.licenseList = fileList;
    },
    handleLicenseRemove(file, fileList) {
      this.licenseList = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addForm) {
        this.formData.append(key, this.addForm[key]);
      }
    },
    handleParse(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList.length < 5) {
            that.licenseList.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    submitAddUpload(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.licenseList.length === 0) {
            this.$message.error("请上传年报提交成功图片");
            return;
          }
          this.licenseList.forEach((file) => this.formData.append("file[]", file.raw));
          for (let key in this.addForm) {
            this.formData.append(key, this.addForm[key]);
          }
          this.$axios.post("/api/annals/upload", this.formData).then((res) => {
            let { data } = res;
            if (data.code === 0) {
              this.$message.success(data.msg);
              if (data.data.stateRow && !Array.isArray(data.data.stateRow)) {
                this.annals[this.addForm.index].annals_state.unshift(data.data.stateRow);
              }
              this.annals[this.addForm.index].annals_upload.unshift(data.data.record);
              this.uploadingDrawer = false;
              this.$refs["addForm"].resetFields();
              this.licenseList = [];
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    },
    handleAddClose(done) {
      this.$refs["addForm"].resetFields();
      this.licenseList = [];
      this.formData = null;
      done();
    },
    pickerDataChangeUpload(val) {
      if (val) {
        this.addForm.year = val;
      } else {
        this.addForm.year = "";
      }
    },
    handleAddAddress(row, index) {
      this.addressForm.cid = row.id;
      this.addressForm.index = index;
      this.addressForm.cname = row.company_name;
      this.addressForm.year = this.list_year;
      this.formDrawer = true;
    },
    handleAddAddressForm() {
      this.$axios.post("/api/annals/form", this.addressForm).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          if (data.data.stateRow && !Array.isArray(data.data.stateRow)) {
            this.annals[this.addressForm.index].annals_state.unshift(data.data.stateRow);
          }
          this.annals[this.addressForm.index].annals_form.unshift(data.data.record);
          this.formDrawer = false;
          this.addressForm.index = null;
          this.addressForm.cid = null;
          this.addressForm.cname = "";
          this.addressForm.year = "";
          this.addressForm.legaler = "";
          this.addressForm.phone = "";
          this.addressForm.address = "";
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    remoteCompanyMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.searchCompanys(query);
        }, 200);
      } else {
        this.companies = [];
      }
    },
    searchCompanys(query) {
      this.$axios.get("/api/admin/searchCompany?name=" + query).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.companies = data.data.companies;
        }
      });
    },
    handleDateTimeChange(val) {
      this.pageOption.currentPage = 1;
      this.getPageDatas();
    },
    handleCompanyChange(val) {
      this.pageOption.currentPage = 1;
      this.getPageDatas();
    },
    handleClear() {
      this.searchArr.cid = '';
    },
    handleSearchGetData() {
      this.searchVisible = false;
      this.getPageDatas();
    },
    handleClearSearchGetData() {
      this.searchArr.leader_id = "";
      this.searchArr.acc_id = "";
      this.searchArr.ass_id = "";
      this.searchArr.saler_id = "";
      this.searchArr.advisory_id = "";
      this.searchArr.invoice_id = "";
      this.searchArr.is_bind = "";
      this.searchArr.is_subscribe = "";
      this.searchArr.is_date_of_est = "1";
      this.searchArr.date_of_est = "";
      this.searchArr.archives = "";
      this.searchArr.regStatus = "";
      this.searchArr.base = "";
      this.searchArr.real = "";
      this.searchArr.companyStatus = "";
      this.options_real = [];
      this.searchVisible = false;
      this.searchArr.annual_phone = "";
      this.searchArr.cid = '';
      this.getPageDatas();
    },
    handleChatOpen(chat, companyName) {
      if (chat) {
        this.chatDrawer = true;
        setTimeout(() => {
          this.chatId = chat.chat_id;
          this.chatName = companyName;
        });
      }
    },
    handleOpenAdvice(cid, cname) {
      this.adviceComId = cid;
      this.adviceComName = cname;
      this.categoryIndrawer = true;
    },
    handleChatBeforeClose(done) {
      this.chatId = "";
      this.chatName = "";
      done();
    },
    handleWxChatOpen(chat, companyName) {
      if (chat) {
        this.wxChatDrawer = true;
        setTimeout(() => {
          this.wxWorkChatId = chat.chat_id;
          this.wxWorkchatName = companyName;
        });
      }
    },
    handleWxChatBeforeClose(done) {
      this.wxWorkChatId = "";
      this.wxWorkchatCompany = "";
      done();
    },
    handleBatchAnnals() {
      this.batchDialog = true;
    },
    exportReminded() {
      this.exportDialog = true;
    },
    multiSetAnnualPhone() {
      this.$axios
        .get(this.hyperfHost + "/v1/api/annual/multiple_set_annual_phone")
        .then(({ data }) => {
          if (data.code === 200) {
            this.$message.success(data.msg);
          } else {
            this.$message.error("提交失败!");
          }
        })
        .catch();
    },
    batchSendInform1() {
      if (!this.dateTime) {
        this.$message.error("请选择月份");
        return;
      }
      this.$axios
        .post("/api/annals/batch_inform", {
          dateTime: this.dateTime,
          batchArr: this.batchArr,
          // phoneType: this.checkList
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1002) {
            this.$message.error(data.msg);
          }
          this.$message.success(data.msg);
          this.getPageDatas();
        });
      this.batchDialog = false;
    },
    batchSendInform() {
      if (!this.dateTime) {
        this.$message.error("请选择月份");
        return;
      }
      this.$axios
        .post("/api/annals/batch_inform?&" + this.searchStr, {
          dateTime: this.dateTime,
          // batchArr: this.batchArr,
          // phoneType: this.checkList
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1002) {
            this.$message.error(data.msg);
          }
          this.$message.success(data.msg);
          // this.getPageDatas();
        });
      this.batchDialog = false;
    },
    doExport() {
      // if (!this.dateTimeExport) {
      //   this.$message.error('请选择月份')
      //   return
      // }
      this.$axios
        .post(
          "api/annals/export_remineded",
          {
            search: this.searchArr,
          },
          { responseType: "blob" }
        )
        .then(({ data }) => {
          let blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          let objectUrl = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = objectUrl;
          link.download = "已通知.xlsx";
          link.click();
          setTimeout(function () {
            window.URL.revokeObjectURL(objectUrl);
          }, 10);
        })
        .catch();
    },
    handleOpen(row, index) {
      this.showTabPane = "first";
      this.secondTab_needId = "";
      this.secondTab_needId = row.id;
      this.companyName = row.company_name;
      this.$axios.get("/api/annals/records/" + row.id).then((res) => {
        const { data } = res;
        this.infoRecord = data.data.records;
      });
      this.serviceDrawer = true;
    },
    handleSureChange(item) {
      if (this.isShowEdit) {
        this.isShowEdit = false;
        this.buttonText = "编辑信息";
        this.editData.field = "";
        this.editData.legaler = "";
        this.editData.phone = "";
        this.editData.address = "";
      } else {
        this.buttonText = "编辑完成";
        this.isShowEdit = true;
        this.editData.legaler = item.remark.legaler;
        this.editData.phone = item.remark.phone;
        this.editData.address = item.remark.address;
      }
    },
    handleEditRemarkMsg(id, field) {
      this.editData.field = field;
      this.$axios.post("/api/annals/up_remark/" + id, this.editData).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          for (let key in this.infoRecord) {
            for (let key2 in this.infoRecord[key].record) {
              if (this.infoRecord[key].record[key2].id === data.data.id) {
                this.infoRecord[key].record[key2] = data.data;
              }
            }
          }
        }
      });
    },
    handCallLogsOpen(row) {
      this.callLogsDrawer = true;
      setTimeout(() => {
        this.company = row.company_name;
        if (row.user) this.callPhone.push(row.user.phone);
        if (row.docking_phone) this.callPhone3.push(row.docking_phone);
        if (row.orders.length > 0) {
          for (let i = 0; i < row.orders.length; i++) {
            if (
              row.orders[i].customer_phone &&
              this.callPhone1.indexOf(row.orders[i].customer_phone) === -1
            ) {
              this.callPhone1.push(row.orders[i].customer_phone);
            }
            if (
              row.orders[i].corporate_phone &&
              this.callPhone2.indexOf(row.orders[i].corporate_phone) === -1
            ) {
              this.callPhone2.push(row.orders[i].corporate_phone);
            }
          }
        }
      });
    },
    handleCallLogsBeforeClose(done) {
      this.company = "";
      this.callPhone = [];
      this.callPhone1 = [];
      this.callPhone2 = [];
      this.callPhone3 = [];
      done();
    },
    handleQyChatOpen(chat, chatName) {
      if (chat) {
        this.qyChatDrawer = true;
        setTimeout(() => {
          this.qyChatId = chat.chat_id;
          this.qyChatName = chatName;
        });
      }
    },
    handleQyChatBeforeClose(done) {
      this.qyChatId = "";
      this.qyChatName = "";
      done();
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    }
  },
  mounted() {
    //     console.log(this.getCustomerAndCorporatePhone(
    // [{company_id: 2, customer_phone: null, corporate_phone: null, vagary_phone: null}]));
    this.getPageDatas();
  },
};
</script>

<style scoped>
.current-year {
  color: #f56c6c;
}

.other-year {
  color: #67c23a;
}

.phone-item {
  text-align: left !important;
  width: 120px;
  margin-top: 0.2rem;
}

.wrapper .el-checkbox {
  text-align: left;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.btn-w {
  width: 3.5rem !important;
}
</style>
<style scoped lang="stylus">
@import '~styles/varibles.styl';
@import '~styles/vertical.styl';
@import '~styles/icon.styl';

.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.annals >>> .success-row {
  background: #f0f9eb;
}

.annals >>> .el-table__header th {
  color: #333;
  background-color: #ecf4ff;
}

.el-drawer__wrapper >>> .el-timeline-item__wrapper {
  top: 0;
}

.el-timeline-item__node--large {
  width: 0.4rem;
  height: 0.4rem;
}

.public {
  display: flex;
  width: 100%;
  box-sizing: border-box;
}

.el-date-editor {
  width: 100% !important;
}

.mt-10 {
  margin-top: 0.2rem;
}

.el-select, .el-cascader {
  width: 100%;
}

.image {
  width: 2rem;
  height: 2rem;
  border-radius: 3px;
}

.el-checkbox {
  width: 100px;
  text-align: center;
}

.col-margin {
  margin: 5px 0 5px 0;
}

.annals {
  padding: 1.42rem 0.4rem 0.4rem 0.4rem;
  max-height: 100vh;
  .header-style {
    z-index: 2;
    height: 110px !important;
    padding: 0 !important;
  }
  .main-style {
    z-index: 1;
    padding: 0px !important;
    overflow-y: auto;
  }
  .footer-style {
    text-align: right;
    .el-pagination {
      padding-top: 10px;
    }
  }

  .drawer-content {
    padding: 0 0.4rem 0 0.4rem;
  }

  .hide-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .text-r {
    text-align: right;
    margin: 15px 0 0 0;
  }

  .m-label {
    line-height: 0.56rem;
    margin: 3px 0 3px 0;
  }

  .popover_span {
    .el-position {
      font-family: Arial, 'Microsoft Yahei', 'Helvetica Neue', Helvetica, sans-serif;
    }
  }

  .count_style {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .icon-qingtonghuiyuan {
    color: #E9935D;
  }

  .icon-baiyinhuiyuan {
    color: #E6E8FA;
  }

  .icon-huangjinhuiyuan {
    color: #FFD32F;
  }

  .icon-qingtong {
    color: #40BBEC;
  }

  .icon-zuanshi {
    color: #83A4FF;
  }

  .icon-wangzhe {
    color: #A8A8A8;
  }

  .el-icon-chat-dot-square {
    color: #88D023;
  }
}

.el-drawer__wrapper >>> .el-drawer__header span {
  color: #4c87fc;
  font-size: 0.36rem;
  font-weight: 400;
}

.el-drawer__wrapper >>> .el-timeline-item__wrapper {
  top: 0;
}

.el-collapse >>> .el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.el-collapse >>> .el-collapse-item__arrow {
  color: #4C87FC;
}
</style>



// WEBPACK FOOTER //
// src/pages/annals/Annals.vue